import apiOptions from '@/api/vo/option';

const defaultState = () => ({
	provinces: [],
	cities: [],
	optProvince: [],
	optCity: [],
	listBank: [],
	listBankCities: [],
	optionDownline: [],
});

const state = defaultState();

const getters = {
};

const mutations = {

	setProvince(state, data) {
		state.provinces = data.data
	},
	setCity(state, data) {
		state.cities = data.data
	},
	setOptProvince(state, data) {
		state.optProvince = data.data
	},
	setOptCity(state, data) {
		state.optCity = data.data
	},
	setListBank(state, data) {
		state.listBank = data.data
	},
	setListBankCities(state, data) {
		state.listBankCities = data.data
	},
	setOptionDownline(state, data) {
		state.optionDownline = data.data
	},
	
	clearOptions(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {

	async getOptionProvince({ dispatch, commit }) {
		return new Promise((resolve, reject) => {
			apiOptions.getOptionProvince().then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setOptProvince', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setOptProvince', []);
				reject()
			});
		});
	},

	async getOptionCity({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOptions.getOptionCity(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setOptCity', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setOptCity', []);
				reject()
			});
		});
	},

	async getProvince({ dispatch, commit }) {
		return new Promise((resolve, reject) => {
			apiOptions.getProvince().then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setProvince', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setProvince', []);
				reject()
			});
		});
	},

	async getCity({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOptions.getCity(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setCity', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setCity', []);
				reject()
			});
		});
	},

	async getBank({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOptions.getBank(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListBank', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setListBank', []);
				reject()
			});
		});
	},

	async getBankCity({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOptions.getCity(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListBankCities', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setListBankCities', []);
				reject()
			});
		});
	},

	async getOptionBank({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOptions.getOptionBank(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListBank', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setListBank', []);
				reject()
			});
		});
	},

	async getOptionDownline({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOptions.getOptionDownline(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setOptionDownline', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setOptionDownline', []);
				reject()
			});
		});
	},
	
	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};